export default __webpack_public_path__ + "static/media/ff4.f4225b70.jpg";